import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Dialog,
  IconButton,
  Chip,
  Paper,
  Typography,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import InputLabel from "@material-ui/core/InputLabel";
import { getUserAccessDetails } from "../../../../../../API/AccessControl";
import ModalDialogContext from "../../../../../../Context/ModalDialog/ModalDialogContext";
import { LoadingIndicator } from "../../../../../../Component";
import styles from "./styles";
//import { getListValues } from "../../../../API/List";
import { useTranslation } from "react-i18next";
import { recordTypes } from "../../../../../../API/config";
import CustomButton from "../../../../../../Component/CustomButton";

const useStyles = makeStyles(styles);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const ViewUserAccess = (props) => {
  const { open, onclose, userEmail } = props;
  const classes = useStyles();

  const [isDialogOpen, setIsDialogOpen] = useState(open);
  const [loading, setLoading] = useState(false);
  const [accessRules, setAccessRules] = useState({});

  const { showErrorMessage } = useContext(
    ModalDialogContext
  );
  const { t } = useTranslation();

  useEffect(() => {
    const loadRules = async () => {
      try {
        setLoading(true);
        const result = await getUserAccessDetails(userEmail);
        const { data = [] } = result;
        setAccessRules(data);
        setLoading(false);
      } catch (error) {
        showErrorMessage({ error });
        setLoading(false);
      }
    };
    if (open) {
      setIsDialogOpen(true);
      loadRules();
    }
  }, [open]);

  const handleClose = () => {
    setIsDialogOpen(false);
    if (onclose) {
      onclose("cancel");
    }
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const displayUserGroups = () => {
    return (
      <Paper component="ul" className={classes.chipPanel}>
        {(!accessRules.userGroups || accessRules.userGroups.length == 0) && <Chip
          label={t("labels.common.none")}
          className={classes.chip}
        />
        }
        {accessRules.userGroups && accessRules.userGroups.length > 0 && accessRules.userGroups.map((ug) => {
          return (
            <li key={ug}>
              <Chip
                //icon={<IconButton title={"view users"} edge="start" size="small"><FaceIcon /></IconButton>}
                label={ug}
                //onDelete={() => { }}
                className={classes.chip}
              />
            </li>
          );
        })}
      </Paper>
    );
  };

  const displayPermissions = (recordType) => {
    const { permissions = {} } = accessRules || {};
    const globalPermission = permissions["*"] || {};
    let rtPermission = permissions[recordType.name];
    if (!rtPermission) {
      rtPermission = permissions["*"] || {};
    }
    const actions = Object.keys(recordType.actions)
      .map((a) => recordType.actions[a]).filter((a) => !a.internal && !a.legacy);
    return (
      <TableContainer component={Paper} key={recordType.name}>
        <Table size="small" >
          <TableHead>
            <TableRow>
              <TableCell className={classes.headerTop} align="center" colSpan="3">{recordType.label}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.headerTop} align="left">
                {t("labels.accessControl.rule.table.headers.permission")}
              </TableCell>
              <TableCell className={classes.headerTop} align="center">
                {t("labels.accessControl.rule.table.headers.allowDeny")}
              </TableCell>
              <TableCell className={classes.headerTop} align="center">
                {t("labels.accessControl.rule.table.headers.conditions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              actions.map((action) => {
                let actionPermission = rtPermission[action.name];
                if (actionPermission === undefined) {
                  actionPermission = rtPermission["*"];
                }
                if (actionPermission === undefined) {
                  actionPermission = globalPermission[action.name];
                }
                if (actionPermission === undefined) {
                  actionPermission = globalPermission["*"] || false;
                }
                const allowDeny = actionPermission === false ?
                  t("labels.accessControl.rule.deny") :
                  t("labels.accessControl.rule.allow");
                const allowDenyClass = actionPermission === true ? classes.greenBold :
                  actionPermission === false ? classes.red : classes.green;
                return (
                  <TableRow key={action.name}>
                    <TableCell className={classes.rightBorder} width="30%">
                      {action.label || action.name}
                    </TableCell>
                    <TableCell className={classes.rightBorder} width="20%" align="center">
                      <span className={allowDenyClass}>{allowDeny}</span>
                    </TableCell>
                    <TableCell align="center" >
                      {actionPermission !== true && actionPermission !== false ?
                        displayConditions(actionPermission) : t("labels.common.none")}
                    </TableCell>
                  </TableRow>
                )
              }
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
    )
  };

  const displayConditions = (conditions) => {
    const {
      //onlyProvidedUrns,
      confidential,
      checkTypes,
      cancelledCheck,
      riskFactors,
      scoringStatuses,
      ownerInSameGoup,
      onlyIfOwner,
      onlyUserCountry,
      countryIds,
      geographyId,
      processStates,
      entityCategories,
      entitySubCategories,
      onlyForSelf
    } = conditions;
    return (
      <Grid container justify="center">
        <Grid item>
          <ul className={classes.listItem}>
            {confidential !== undefined && <li alignItems="center" key={"confidential"} >
              {confidential ?
                t("labels.accessControl.rule.conditions.confidential") :
                t("labels.accessControl.rule.conditions.notConfidential")
              }
            </li>}
            {checkTypes && checkTypes.length > 0 && <li alignItems="center" key={"checkTypes"}>
              {t("labels.accessControl.rule.conditions.ckeckType", {
                checkTypes: checkTypes.join(` ${t("labels.common.or")} `)
              })}
            </li>}
            {cancelledCheck !== undefined && <li alignItems="center" key={"cancelledCheck"}>
              {cancelledCheck ?
                t("labels.accessControl.rule.conditions.cancelledCheck") :
                t("labels.accessControl.rule.conditions.notCancelledCheck")
              }
            </li>}
            {riskFactors && riskFactors.length > 0 && <li alignItems="center" key={"riskFactors"}>
              {t("labels.accessControl.rule.conditions.riskFactors", {
                scores: riskFactors.join(` ${t("labels.common.or")} `)
              })}
            </li>}
            {scoringStatuses && scoringStatuses.length > 0 && <li alignItems="center" key={"scoringStatuses"}>
              {t("labels.accessControl.rule.conditions.scoringStatuses", {
                scoringStatuses: scoringStatuses.join(` ${t("labels.common.or")} `)
              })}
            </li>}
            {ownerInSameGoup !== undefined && <li alignItems="center" key={"ownerInSameGoup"}>
              {t("labels.accessControl.rule.conditions.ownerInSameGoup")}
            </li>}
            {onlyIfOwner !== undefined && <li alignItems="center" key={"onlyIfOwner"}>
              {t("labels.accessControl.rule.conditions.onlyIfOwner")}
            </li>}
            {onlyUserCountry !== undefined && <li alignItems="center" key={"onlyUserCountry"}>
              {t("labels.accessControl.rule.conditions.onlyUserCountry")}
            </li>}
            {countryIds && countryIds.length > 0 && <li alignItems="center" key={"countryIds"}>
              {t("labels.accessControl.rule.conditions.countryIds", {
                countryIds: countryIds.join(` ${t("labels.common.or")} `)
              })}
            </li>}
            {geographyId && geographyId.length > 0 && <li alignItems="center" key={"geographyId"}>
              {t("labels.accessControl.rule.conditions.geographyId")}
            </li>}
            {processStates && processStates.length > 0 && <li alignItems="center" key={"processStates"}>
              {t("labels.accessControl.rule.conditions.processStates", {
                processStates: processStates.join(` ${t("labels.common.or")} `)
              })}
            </li>}
            {entityCategories && entityCategories.length > 0 && <li alignItems="center" key={"entityCategories"}>
              {t("labels.accessControl.rule.conditions.entityCategories", {
                entityCategories: entityCategories.join(` ${t("labels.common.or")} `)
              })}
            </li>}
            {entitySubCategories && entitySubCategories.length > 0 && <li alignItems="center" key={"entitySubCategories"}>
              {t("labels.accessControl.rule.conditions.entitySubCategories", {
                entitySubCategories: entitySubCategories.join(` ${t("labels.common.or")} `)
              })}
            </li>}
          </ul>
        </Grid>
      </Grid>
    );
  };

  const renderViewForm = () => {
    return (
      <Grid container direction="row" spacing={3}>
        <Grid item sm={6} md={6} xs={12}>
          <InputLabel className={classes.inputLabel}>User Email</InputLabel>
          <span> {userEmail}</span>
        </Grid>
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.accessControl.rule.form.userGroups")}</InputLabel>
          {displayUserGroups()}
        </Grid>
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>{t("labels.accessControl.rule.form.permissions")}</InputLabel>
          {Object.keys(recordTypes).map((rt) => (
            displayPermissions(recordTypes[rt])
          ))}
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Dialog
        disableBackdropClick
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isDialogOpen}
        fullWidth={true}
        scroll="paper"
        maxWidth="md"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Typography className={classes.panelTitle}>{t("labels.accessControl.rules.viewUserAccess")}</Typography>
        </DialogTitle>
        <DialogContent dividers>
          {loading ? renderLoadingIndicator() : renderViewForm()}
        </DialogContent>

        <DialogActions>
          <CustomButton variant="secondary" onClick={handleClose}>
            {t("labels.common.close")}
          </CustomButton>
          
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ViewUserAccess;
